import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingStore {

  private readonly _count = signal(0);

  readonly loading = computed(() => this._count() > 0);

  show(): void {
    this._count.update(v => v + 1);
  }

  hide(): void {
    this._count.update(v => Math.max(0, v - 1));
  }
}